import styled from 'styled-components';

export const ContainerAnexo = styled.div`
  display: flex;
  background-color: #eee;
  padding: 10px;
  border-radius: 5px;
  align-items: center;

  .arquivo {
    color: #1890ff !important;
    cursor: pointer;
  }

  .delete {
    margin-left: 15px;
    background-color: transparent;
    border: none;
  }
`;
